import { useCallback, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLanguage } from './useLanguage'
import { runTour } from '../lib/tour'

export function usePageTour(buildSteps, onFinish) {
  const { t } = useLanguage()
  const location = useLocation()
  const navigate = useNavigate()
  const driverRef = useRef(null)
  const latest = useRef({})
  latest.current = { buildSteps, onFinish, t }

  const start = useCallback(() => {
    driverRef.current?.destroy()
    const { buildSteps, onFinish, t } = latest.current
    const steps = buildSteps(t)
    console.log('[tour] iniciando con', steps.length, 'pasos')
    driverRef.current = runTour({ steps, t, onFinish })
  }, [])

  const wantsTour = !!location.state?.tour
  console.log('[tour] render. path:', location.pathname, 'state:', location.state)

  useEffect(() => {
    console.log('[tour] efecto. wantsTour =', wantsTour)
    if (!wantsTour) return
    const { buildSteps, t } = latest.current
    const first = buildSteps(t).find(s => typeof s.element === 'string')?.element
    console.log('[tour] esperando elemento:', first)
    const t0 = Date.now()
    let startTimer
    const poll = setInterval(() => {
      const listo = !first || document.querySelector(first)
      if (listo || Date.now() - t0 > 6000) {
        console.log('[tour] elemento listo:', !!listo)
        clearInterval(poll)
        startTimer = setTimeout(() => {
          start()
          navigate(location.pathname, { replace: true, state: {} })
        }, 400)
      }
    }, 150)
    return () => { clearInterval(poll); clearTimeout(startTimer) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsTour])

  useEffect(() => () => {
    console.log('[tour] desmontando hook (se destruye el tour)')
    driverRef.current?.destroy()
  }, [])

  return start
}